import type { ObjectShorthandValue } from '@archipro-design/aria';
import { Caption } from '@archipro-design/aria';
import { Link } from 'react-router';
import { useCountryContext } from '@archipro-website/localisation';
import type { CaptionProps } from '@archipro-design/aria';

export const PolicyLink = (props: ObjectShorthandValue<CaptionProps>) => {
    const { byCountry } = useCountryContext();

    const policyLink = byCountry({
        AU: 'https://archipro.com.au/privacy-policy',
        NZ: 'https://archipro.co.nz/privacy-policy',
        US: 'https://archiproamerica.com/privacy-policy',
    });

    const linkProp: ObjectShorthandValue<CaptionProps> =
        props.as === 'a'
            ? { as: 'a', href: policyLink }
            : { as: Link, to: policyLink };

    return (
        <Caption variant="02" {...props} {...linkProp}>
            Privacy Policy
        </Caption>
    );
};
